export enum Mode {
    None = 'None',
    Initial = 'initial',
    Completed = 'completed',
    PreviewGeneration = 'previewGeneration',
    DataLoaded = 'dataLoaded',
    HasError = 'hasError',
    ErrorCorrected = 'errorCorrected',
    DataSavedToMaster = 'dataSavedToMaster',
    Concurrent = 'concurrent',
    DataLoadedToPreview = 'dataLoadedToPreview',
    SyncInProgress = 'syncInProgress',
    DataEditorSync = 'dataEditorSync',
    PreviewCleared = 'previewCleared'
}
